(function () {
  'use strict';
  var root = document.querySelector('[data-checker]');
  if (!root) return;
  var pfMain   = document.querySelector('.kh-pf-main');
  var input    = root.querySelector('[data-checker-input]');
  var field    = root.querySelector('[data-checker-field]');
  var suggEl   = root.querySelector('[data-checker-suggestions]');
  var confirm  = root.querySelector('[data-checker-confirmed]');
  var confLbl  = root.querySelector('[data-checker-confirmed-label]');
  var editBtn  = root.querySelector('[data-checker-edit]');
  var resultEl = root.querySelector('[data-checker-result]');
  var pickup   = root.querySelector('[data-checker-pickup]');
  var atcTotal = document.querySelector('[data-atc-total]');
  var atcNote  = document.querySelector('[data-atc-note]');
  var cutoff   = root.getAttribute('data-cutoff') || '1pm';
  var zonesUrl = root.getAttribute('data-zones-url');
  var STUDIO   = 'our Southbank studio';
  var SS_KEY   = 'khf_checker_v1';
  var data = null, loadPromise = null, premiumUrl = '/collections/premium';
  var state = { resolved: false, mode: null, suburb: '', postcode: '', beyond: false, rateCents: null };
  var activeIdx = -1;
  var money = new Intl.NumberFormat('en-AU', { style: 'currency', currency: 'AUD' });
  function fmt(c) { return money.format((c || 0) / 100); }
  function melbNow() {
    try {
      var p = new Intl.DateTimeFormat('en-GB', { timeZone: 'Australia/Melbourne', hour: '2-digit', minute: '2-digit', hour12: false }).formatToParts(new Date());
      return (+p.find(function (x) { return x.type === 'hour'; }).value) * 100 + (+p.find(function (x) { return x.type === 'minute'; }).value);
    } catch (e) { return 0; }
  }
  var afterCutoff = melbNow() >= 1300;
  function timing() { return afterCutoff ? 'Order now for delivery tomorrow.' : 'Order by ' + cutoff + '.'; }
  function loadData() {
    if (loadPromise) return loadPromise;
    loadPromise = fetch(zonesUrl)
      .then(function (r) { return r.json(); })
      .then(function (j) { data = j; if (j && j.premiumUrl) premiumUrl = j.premiumUrl; return j; })
      .catch(function () { data = null; return null; });
    return loadPromise;
  }
  function basePrice() { var p = pfMain && pfMain.getAttribute('data-price'); return p ? parseInt(p, 10) : 0; }
  function upsellTotal() {
    var sum = 0;
    document.querySelectorAll('.kh-pf-card-chb').forEach(function (cb) {
      if (cb.checked || cb.getAttribute('checked') === 'true') sum += parseInt(cb.getAttribute('data-price') || '0', 10) || 0;
    });
    return sum;
  }
  function deliveryCents() {
    if (state.mode === 'pickup') return 0;
    if (state.mode === 'deliver' && state.rateCents != null) return state.rateCents;
    return 0;
  }
  function updateTotal() {
    if (atcTotal) atcTotal.textContent = '— ' + fmt(basePrice() + upsellTotal() + deliveryCents());
    if (!atcNote) return;
    if (state.mode === 'deliver' && state.rateCents != null) atcNote.textContent = 'Includes ' + fmt(state.rateCents) + ' delivery to ' + state.suburb + '.';
    else if (state.mode === 'pickup') atcNote.textContent = 'Free studio pickup — no delivery fee.';
    else if (state.mode === 'deliver') atcNote.textContent = 'Please call the store for a delivery quote to ' + state.suburb + '.';
    else atcNote.textContent = '';
  }
  function showField() { field.classList.remove('rdc-d-none'); confirm.classList.add('rdc-d-none'); input.focus(); }
  function showConfirmed(html) { confLbl.innerHTML = html; field.classList.add('rdc-d-none'); confirm.classList.remove('rdc-d-none'); hideSuggestions(); }
  function setResult(text, cls) { resultEl.textContent = ''; resultEl.className = 'kh-pf-checker-result' + (cls ? ' ' + cls : ''); if (text) resultEl.innerHTML = text; }
  function confirmedHtml() { return 'Delivery to <strong>' + state.suburb + ' ' + state.postcode + '</strong>'; }
  function renderResolved() {
    if (state.mode === 'pickup') {
      showConfirmed('Pick up from ' + STUDIO);
      setResult('Free pickup from ' + STUDIO + ', usually ready within the hour.', 'is-pickup');
    } else if (state.rateCents == null) {
      showConfirmed(confirmedHtml());
      setResult('We deliver to ' + state.suburb + ', however this location needs to be arranged personally with our team. Please call <a href="tel:+61395108800">+61 3 9510 8800</a> and we\'ll be happy to help.', 'is-callstore');
    } else {
      showConfirmed(confirmedHtml());
      setResult('Same-day delivery to ' + state.suburb + ' — <span class="kh-pf-checker-rate">' + fmt(state.rateCents) + '</span>. ' + timing(), '');
    }
    updateTotal();
  }
  function resolveSuburb(sub) {
    state.resolved = true;
    state.mode = 'deliver';
    state.suburb = sub.name;
    state.postcode = sub.postcode;
    state.beyond = !!sub.beyond;
    state.rateCents = sub.rate != null ? Math.round(sub.rate * 100) : null;
    renderResolved();
    persist();
    log(state.rateCents == null ? 'unknown' : (state.beyond ? 'beyond_rate' : 'in_promise'));
  }
  function resolveUnknown(q) {
    state.resolved = false; state.mode = null; state.suburb = ''; state.rateCents = null;
    hideSuggestions();
    if (/^3\d{3}$/.test(q)) { setResult('We may still reach you — please call the store.', 'is-unknown'); log('unknown'); }
    else setResult('Enter a Victorian suburb or postcode.', 'is-invalid');
    updateTotal();
  }
  function choosePickup() {
    state.resolved = true; state.mode = 'pickup'; state.suburb = ''; state.postcode = ''; state.beyond = false; state.rateCents = 0;
    renderResolved(); persist(); log('pickup');
  }
  function matches(q) {
    if (!data || !data.suburbs) return [];
    var out = [];
    if (/^\d+$/.test(q)) {
      for (var i = 0; i < data.suburbs.length; i++) { if (data.suburbs[i].postcode.indexOf(q) === 0) out.push(data.suburbs[i]); if (out.length >= 8) break; }
    } else {
      var lc = q.toLowerCase();
      for (var j = 0; j < data.suburbs.length; j++) { if (data.suburbs[j].name.toLowerCase().indexOf(lc) !== -1) out.push(data.suburbs[j]); if (out.length >= 8) break; }
    }
    return out;
  }
  function hideSuggestions() { suggEl.classList.add('rdc-d-none'); suggEl.innerHTML = ''; activeIdx = -1; }
  function renderSuggestions(list) {
    suggEl.innerHTML = '';
    if (!list.length) { hideSuggestions(); return; }
    list.forEach(function (sub) {
      var li = document.createElement('li');
      li.textContent = sub.name + ', ' + sub.postcode;
      li.addEventListener('mousedown', function (e) { e.preventDefault(); resolveSuburb(sub); });
      suggEl.appendChild(li);
    });
    suggEl.classList.remove('rdc-d-none');
    activeIdx = -1;
  }
  function setActive(idx) {
    var items = suggEl.querySelectorAll('li');
    if (!items.length) return;
    activeIdx = (idx + items.length) % items.length;
    items.forEach(function (el, i) { el.classList.toggle('is-active', i === activeIdx); });
  }
  function persist() { try { sessionStorage.setItem(SS_KEY, JSON.stringify(state)); } catch (e) {} }
  function restore() {
    var raw; try { raw = sessionStorage.getItem(SS_KEY); } catch (e) { return; }
    if (!raw) return;
    try { var s = JSON.parse(raw); if (s && s.resolved) { state = s; renderResolved(); } } catch (e) {}
  }
  function dl(payload) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
    document.dispatchEvent(new CustomEvent('khf:' + payload.event, { detail: payload }));
  }
  function rateVal() { return state.rateCents != null ? state.rateCents / 100 : null; }
  function log(resultState) { dl({ event: 'postcode_lookup', postcode: state.postcode || null, suburb: state.suburb || null, rate: rateVal(), result_state: resultState }); }
  function logAtc() { dl({ event: 'postcode_atc', postcode: state.postcode || null, rate: rateVal(), mode: state.mode || null, beyond: state.beyond, resolved: !!state.resolved }); }
  var atcBtn = document.querySelector('.kh-pf-atc');
  if (atcBtn) atcBtn.addEventListener('click', logAtc);
  var firstFocus = true;
  input.addEventListener('focus', function () { if (firstFocus) { firstFocus = false; loadData(); } });
  input.addEventListener('input', function () {
    var q = input.value.trim();
    if (!q) { hideSuggestions(); setResult('', ''); return; }
    loadData().then(function () { renderSuggestions(matches(q)); });
  });
  input.addEventListener('keydown', function (e) {
    var items = suggEl.querySelectorAll('li');
    if (e.key === 'ArrowDown') { e.preventDefault(); setActive(activeIdx + 1); }
    else if (e.key === 'ArrowUp') { e.preventDefault(); setActive(activeIdx - 1); }
    else if (e.key === 'Enter') { e.preventDefault(); var q = input.value.trim(); if (items.length) { (items[activeIdx > -1 ? activeIdx : 0]).dispatchEvent(new MouseEvent('mousedown')); } else resolveUnknown(q); }
    else if (e.key === 'Escape') { hideSuggestions(); }
  });
  input.addEventListener('blur', function () {
    setTimeout(function () {
      if (!suggEl.classList.contains('rdc-d-none') && suggEl.querySelector('li')) return;
      var q = input.value.trim();
      if (q && !state.resolved) resolveUnknown(q);
    }, 150);
  });
  editBtn.addEventListener('click', function () { input.value = ''; setResult('', ''); showField(); });
  pickup.addEventListener('click', choosePickup);
  document.addEventListener('change', function (e) { if (e.target && e.target.classList && e.target.classList.contains('kh-pf-card-chb')) updateTotal(); });
  document.addEventListener('click', function (e) { if (e.target && e.target.closest && e.target.closest('.kh-pf-card')) setTimeout(updateTotal, 0); });
  updateTotal();
  restore();
})();
